import { rgba } from 'polished';
import styled from 'styled-components';

const COLOR_PRIMARY = '#F78E1E';
const COLOR_TEXT = '#263238';
const COLOR_MUTED = '#8C8C8C';
const COLOR_BORDER = '#E8EAED';
const COLOR_SURFACE_ALT = '#FBFCFE';

export const Container = styled.section`
  width: 100%;
  padding: 24px;
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: auto;

  @media (max-width: 599px) {
    padding: 16px;
  }
`;

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 24px;
`;

export const HeroDate = styled.span`
  font: 12px 'Roboto', sans-serif;
  color: ${COLOR_MUTED};

  @media (min-width: 1280px) {
    font-size: 13px;
  }
`;

export const HeroGreeting = styled.h1`
  font: 22px 'Roboto', sans-serif;
  font-weight: 600;
  line-height: 28px;
  color: ${COLOR_TEXT};
  margin: 0;

  @media (max-width: 599px) {
    font-size: 20px;
    line-height: 26px;
  }

  @media (min-width: 1280px) {
    font-size: 26px;
    line-height: 32px;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
`;

export const Section = styled.div`
  margin-top: 28px;

  @media (max-width: 599px) {
    margin-top: 24px;
  }
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const Subtitle = styled.span`
  font: 12px 'Roboto', sans-serif;
  color: ${COLOR_MUTED};

  @media (min-width: 1280px) {
    font-size: 13px;
  }
`;

export const Title = styled.h2`
  font: 16px 'Roboto', sans-serif;
  font-weight: 600;
  color: ${COLOR_TEXT};
  margin: 0;

  @media (max-width: 599px) {
    font-size: 15px;
  }

  @media (min-width: 1280px) {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const CustomizeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border: 1px solid #d9d9d9;
  border-radius: 18px;
  background-color: #fff;
  color: ${COLOR_TEXT};
  font: 13px 'Roboto', sans-serif;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    border-color: ${COLOR_PRIMARY};
    color: ${COLOR_PRIMARY};
  }

  span[role='img'] {
    font-size: 14px;
  }

  @media (max-width: 599px) {
    height: 40px;
    padding: 0 12px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 16px;
  }
`;

export const Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
  min-height: 116px;
  padding: 16px;
  border: 1px solid ${COLOR_BORDER};
  border-radius: 12px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;

  &:hover {
    border-color: ${COLOR_PRIMARY};
    transform: translateY(-2px);
    box-shadow: 0 8px 20px ${rgba(COLOR_PRIMARY, 0.16)};
  }

  &:active {
    transform: translateY(0);
    box-shadow: none;
  }

  @media (max-width: 599px) {
    flex-direction: row;
    align-items: center;
    min-height: 68px;
    padding: 12px 14px;
    gap: 12px;
  }
`;

export const IconBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: ${rgba(COLOR_PRIMARY, 0.12)};
  color: ${COLOR_PRIMARY};
  font-size: 18px;
  flex-shrink: 0;
`;

export const CardTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const CardTitle = styled.strong`
  font: 14px 'Roboto', sans-serif;
  font-weight: 600;
  line-height: 18px;
  color: ${COLOR_TEXT};
  overflow-wrap: anywhere;
`;

export const CardParent = styled.span`
  font: 11px 'Roboto', sans-serif;
  color: ${COLOR_MUTED};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RecentsWrapper = styled.div`
  margin-top: 28px;

  @media (max-width: 599px) {
    margin-top: 24px;
  }
`;

export const RecentsTitle = styled.h3`
  font: 12px 'Roboto', sans-serif;
  font-weight: 500;
  color: ${COLOR_MUTED};
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0 0 10px 0;
`;

export const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Chip = styled.button`
  height: 36px;
  padding: 0 14px;
  border: 1px solid ${COLOR_BORDER};
  border-radius: 18px;
  background-color: ${COLOR_SURFACE_ALT};
  color: ${COLOR_TEXT};
  font: 13px 'Roboto', sans-serif;
  cursor: pointer;
  transition: all 0.18s ease;

  &:hover {
    border-color: ${COLOR_PRIMARY};
    color: ${COLOR_PRIMARY};
    background-color: #fff;
  }

  @media (max-width: 599px) {
    height: 40px;
  }
`;
